<template>
  <div class="page-body" style="overflow: scroll; width: 100%; height: 90vh">
    <div style="margin-top: 10px;" v-permission:function="['allCaseData']">
      <div class="box-item" style="background-color: white;width: 97%;height:45;padding: 10px ; ">
        <el-row style="margin:30px;">
          <el-col :span="6">
            <span align="right" style="display: inline-block;line-height: 40px">案由：</span>
            <el-select clearable @change="dateChange()" v-model="cause" placeholder="选择案由"
              style="width: 70%; margin-left: 10px">
              <el-option v-for="item in causeList" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <span align="right" style="display: inline-block;line-height: 40px">条件：</span>
            <el-select v-model="dateType" placeholder="请选择" @change="dateChange()">
              <el-option v-for="item in dateOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>

          <el-col :span="12">
            <span style="display: inline-block; line-height: 40px">条件区间：</span>
            <el-date-picker v-model="dateRange" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              @change="dateChange()">
            </el-date-picker>
          </el-col>
        </el-row>
        <el-row style="margin:10px">
          <el-col :span="6">
            <div class="grid-content"><el-button ref="btn1" type="text" @click="statistics('all')">全部</el-button></div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content"><el-button ref="btn2" type="text" @click="statistics('year')">年度统计</el-button>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content "><el-button ref="btn3" type="text" @click="statistics('month')">月度统计</el-button>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content "><el-button ref="btn4" type="text" @click="statistics('day')">当日统计</el-button>
            </div>
          </el-col>


        </el-row>

      </div>
    </div>


    <div class="countBox" v-if="isShowBox">
      <el-tooltip class="item" effect="dark" content="系统案件总数" placement="top">
        <div class="box-item">
          <div class="box-card text-class">
            <div style="height: 100%">
              <!-- <div class="el-icon-platform-eleme" style="width:50%;height:50px;margin:auto auto">
            </div> -->
              <el-row style="padding: 3vh">
                <el-col :span="8" class="colCenter"><img style="height: 6vh"
                    :src="`${$baseUrl}image/boxImg/allCase.png`" /></el-col>
                <el-col :span="16" style="padding: 1vh; height: 3vh">
                  <span style="font-size: 1.3rem; font-weight: bold">总案件数量</span>
                  <el-row class="two-row" style="margin-top: 2px">
                    <el-col :span="24" style="height: 3vh; line-height: 3vh">
                      <el-link type="warning" :underline="false">
                        <div style="font-size: 1.3rem;color: orange;font-weight: bold;" @click="detailList('')">
                          {{ boxData.allCaseCount }}
                        </div>
                      </el-link>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="系统案件中信用卡总数" placement="top">
        <div class="box-item">
          <div class="box-card text-class">
            <div style="height: 100%">
              <!-- <div class="el-icon-platform-eleme" style="width:50%;height:50px;margin:auto auto">
            </div> -->
              <el-row style="padding: 3vh">
                <el-col :span="8" class="colCenter"><img style="height: 6vh"
                    :src="`${$baseUrl}image/boxImg/allCard.png`" /></el-col>
                <el-col :span="16" style="padding: 1vh; font-size: 1.3rem; height: 3vh">
                  <span style="font-size: 1.3rem; font-weight: bold">总信用卡数</span>
                  <el-row class="two-row" style="margin-top: 2px">
                    <el-col :span="24" style="height: 3vh; line-height: 3vh">
                      <div style="
                        font-size: 1.3rem;
                        color: orange;
                        font-weight: bold;
                      ">
                        {{ boxData.cardCount }}
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-tooltip>

      <el-tooltip class="item" effect="dark" content="系统案件中所有案件的标的总额" placement="top">
        <div class="box-item">
          <div class="box-card text-class">
            <div style="height: 100%">
              <!-- <div class="el-icon-platform-eleme" style="width:50%;height:50px;margin:auto auto">
            </div> -->
              <el-row style="padding: 3vh">
                <el-col :span="8" class="colCenter"><img style="height: 6vh"
                    :src="`${$baseUrl}image/boxImg/yiCeSu.png`" /></el-col>
                <el-col :span="16" style="padding: 1vh; font-size: 1.3rem; height: 3vh">
                  <span style="font-size: 1.3rem; font-weight: bold">总标的额</span>
                  <el-row class="two-row" style="margin-top: 2px">
                    <el-col :span="24" style="height: 3vh; line-height: 3vh">
                      <div style="
                        font-size: 1.3rem;
                        color: orange;
                        font-weight: bold;
                      ">
                        {{ boxData.biaodi }}
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-tooltip>

      <el-tooltip class="item" effect="dark" content="系统案件中已经走完所有流程的案件，统计方式为状态是已完成和已撤诉的案件" placement="top">
        <div class="box-item">
          <div class="box-card text-class">
            <div style="height: 100%">
              <!-- <div class="el-icon-platform-eleme" style="width:50%;height:50px;margin:auto auto">
            </div> -->
              <el-row style="padding: 3vh">
                <el-col :span="8" class="colCenter"><img style="height: 6vh"
                    :src="`${$baseUrl}image/boxImg/yijiean.png`" /></el-col>
                <el-col :span="16" style="padding: 1vh; font-size: 1.3rem; height: 3vh">
                  <span style="font-size: 1.3rem; font-weight: bold">结案数量</span>
                  <el-row class="two-row" style="margin-top: 2px">
                    <el-col :span="24" style="height: 3vh; line-height: 3vh">
                      <el-link type="warning" :underline="false">
                        <div style="font-size: 1.3rem;color: orange;font-weight: bold;" @click="detailList('已结案')">
                          {{ boxData.yiWanCheng }}
                        </div>
                      </el-link>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-tooltip>
    </div>

    <div class="countBox" v-if="isShowBox">
      <el-tooltip class="item" effect="dark" content="系统案件中立案的数量，统计方式为已有案号，且状态已经进入缴费中的案件" placement="top">
        <div class="box-item">
          <div class="box-card text-class">
            <div style="height: 100%">
              <!-- <div class="el-icon-platform-eleme" style="width:50%;height:50px;margin:auto auto">
            </div> -->
              <el-row style="padding: 3vh">
                <el-col :span="8" class="colCenter"><img style="height: 6vh"
                    :src="`${$baseUrl}image/boxImg/yilian.png`" /></el-col>
                <el-col :span="16" style="padding: 1vh; font-size: 1.3rem; height: 3vh">
                  <span style="font-size: 1.3rem; font-weight: bold">立案数量</span>
                  <el-row class="two-row" style="margin-top: 2px">
                    <el-col :span="24" style="height: 3vh; line-height: 3vh">
                      <el-link type="warning" :underline="false">
                        <div style="font-size: 1.3rem;color: orange;font-weight: bold;" @click="detailList('已立案')">
                          {{ boxData.yiLiAn }}
                        </div>
                      </el-link>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="系统案件中已调解成功的案件，统计方式为有调解号，且案件状态为调解成功和调解方案履行中" placement="top">
        <div class="box-item">
          <div class="box-card">
            <div style="height: 100%">
              <el-row style="padding: 2vh">
                <el-col :span="8" class="colCenter"><img style="height: 6vh"
                    :src="`${$baseUrl}image/boxImg/mediateSuccess.png`" /></el-col>
                <el-col :span="16" style="padding: 1vh; font-size: 1.3rem; height: 3vh">
                  <span style="font-size: 1.3rem; font-weight: bold">调解成功数量</span>
                  <el-row class="two-row" style="margin-top: 2px">
                    <el-col :span="24" style="height: 3vh; line-height: 3vh">
                      <el-link type="warning" :underline="false">
                        <div style="font-size: 1.3rem;color: orange;font-weight: bold;" @click="detailList('调解成功')">
                          {{ boxData.tiaoJieChengGong }}
                        </div>
                      </el-link>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-tooltip>



      <el-tooltip class="item" effect="dark" content="撤诉中和已撤诉案件数量" placement="top">
        <div class="box-item">
          <div class="box-card text-class">
            <div style="height: 100%">
              <el-row style="padding: 3vh">
                <el-col :span="8" class="colCenter"><img style="height: 6vh"
                    :src="`${$baseUrl}image/boxImg/yiCeSu.png`" /></el-col>
                <el-col :span="16" style="padding: 1vh; font-size: 1.3rem; height: 3vh">
                  <span style="font-size: 1.3rem; font-weight: bold">撤诉数量</span>
                  <el-row class="two-row" style="margin-top: 2px">
                    <el-col :span="24" style="height: 3vh; line-height: 3vh">
                      <el-link type="warning" :underline="false">
                        <div style="font-size: 1.3rem;color: orange;font-weight: bold;" @click="detailList('已撤诉')">
                          {{ boxData.yiCeSu }}
                        </div>
                      </el-link>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="因各种原因退回给客户的案件" placement="top">
        <div class="box-item">
          <div class="box-card text-class">
            <div style="height: 100%">
              <!-- <div class="el-icon-platform-eleme" style="width:50%;height:50px;margin:auto auto">
            </div> -->
              <el-row style="padding: 3vh">
                <el-col :span="8" class="colCenter"><img style="height: 6vh"
                    :src="`${$baseUrl}image/boxImg/yiTuiAn.png`" /></el-col>
                <el-col :span="16" style="padding: 1vh; font-size: 1.3rem; height: 3vh">
                  <span style="font-size: 1.3rem; font-weight: bold">退案数量</span>
                  <el-row class="two-row" style="margin-top: 2px">
                    <el-col :span="24" style="height: 3vh; line-height: 3vh">
                      <el-link type="warning" :underline="false">
                        <div style="font-size: 1.3rem;color: orange;font-weight: bold;" @click="detailList('已退案')">
                          {{ boxData.yiTuiAn }}
                        </div>
                      </el-link>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>

      </el-tooltip>
    </div>
    <div style="">
      <div class="content box1" style="" v-if="allImg.length > 0">
        <div v-for="item in allImg.slice(0, 2)" :key="item" class="imgClass" style="width: 48%; margin: 0 1% 1% 1%"
          :id="item"></div>
      </div>
      <div class="content box2" style="margin-top: 20px" v-if="allImg.length > 0">
        <div class="imgClass" v-for="item in allImg.slice(2, 4)" :key="item" :id="item"
          style="width: 48%; margin: 0 1% 1% 1%"></div>
      </div>
    </div>

    <el-dialog :title="query.countType == '' ? '总案件数' : query.countType" :visible.sync="centerDialogVisible"
      width="100%" fullscreen center>
      <!-- 案件列表 -->
      <el-table type="index" :data="caseList.records" size="small" stripe row-key highlight-current-row
        style=" margin-top: 4px; overflow: auto">

        <el-table-column width="70" align="center" label="系统编号">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column width="100" align="center" label="批次号">
          <template slot-scope="scope">
            <span>{{ scope.row.batchId }}</span>
          </template>
        </el-table-column>
        <el-table-column width="150" align="center" label="法院名称/案号">
          <template slot-scope="scope">
            <div>{{ scope.row.courtName }}</div>
            <div>{{ scope.row.registerCode }}</div>
          </template>
        </el-table-column>
        <el-table-column width="200" align="center" label="当事人">
          <template slot-scope="scope">
            <el-link :underline="false" @click="showEditPage(scope.$index, scope.row)">
              <div style="font-size: 12px;">{{ scope.row.plaintiffName }}</div>
            </el-link>
            <el-link type="primary" :underline="false" @click="showEditPage(scope.$index, scope.row)">
              <div>{{ scope.row.defendantName }}</div>
            </el-link>
          </template>
        </el-table-column>

        <el-table-column width="120" align="center" label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.caseStatus == '未处置' || scope.row.caseStatus == '异常'" type="info">{{
              scope.row.caseStatus }}</el-tag>
            <el-tag
              v-else-if="scope.row.caseStatus == '处置中' || scope.row.caseStatus == '提交诉讼服务网' || scope.row.caseStatus == '提交法院'"
              type="warning">{{ scope.row.caseStatus }}</el-tag>
            <el-tag
              v-else-if="scope.row.caseStatus == '已完成' || scope.row.caseStatus == '已撤诉' || scope.row.caseStatus == '已退案'"
              type="success">{{ scope.row.caseStatus }}</el-tag>
            <el-tag
              v-else-if="scope.row.caseStatus == '调解中' || scope.row.caseStatus == '调解成功' || scope.row.caseStatus == '调解方案履行中'"
              type="primary">{{ scope.row.caseStatus }}</el-tag>
            <el-tag v-else type="danger">{{ scope.row.caseStatus }}</el-tag>
            <div v-if="scope.row.caseStatus == '已撤诉'">{{ scope.row.dropLawsuitReason }}</div>
            <div v-if="scope.row.caseStatus == '已退案'">{{ scope.row.withdrawalReason }}</div>
          </template>
        </el-table-column>
        <el-table-column width="100" align="center" label="标的">
          <template slot-scope="scope">
            <span>{{ scope.row.underlyingAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column width="100" align="center" label="备注">
          <template slot-scope="scope">
            <span>{{ scope.row.remark }}</span>
          </template>
        </el-table-column>

        <el-table-column width="120" align="center" label="立案日期" sortable prop="filingDate" column-key="filingDate">
          <template slot-scope="scope">
            <span>{{ scope.row.filingDate }}</span>
          </template>
        </el-table-column>
        <el-table-column width="120" align="center" label="调解成功日期" sortable prop="mediationSuccessDate"
          column-key="mediationSuccessDate">
          <template slot-scope="scope">
            <span>{{ scope.row.mediationSuccessDate }}</span>
          </template>
        </el-table-column>
        <el-table-column width="140" align="center" label="开庭时间" sortable prop="trialDate" column-key="trialDate">
          <template slot-scope="scope">
            <span>{{ scope.row.trialDate }}</span>
          </template>
        </el-table-column>
        <el-table-column width="160" align="center" label="已登记结算日期">
          <template slot-scope="scope">
            <div v-if="scope.row.settleDateFiling !== undefined">
              <el-tag size="mini" effect="effect">立案：{{ scope.row.settleDateFiling }}</el-tag>
            </div>
            <div v-if="scope.row.settleDateDecision !== undefined">
              <el-tag size="mini" effect="plain" type="danger">调解/判决/撤诉：{{ scope.row.settleDateDecision }}</el-tag>
            </div>
            <div v-if="scope.row.settleDateApplyExecution !== undefined">
              <el-tag size="mini" effect="plain" type="warning">申请执行：{{ scope.row.settleDateApplyExecution }}</el-tag>
            </div>
            <div v-if="scope.row.settleDateExecution !== undefined">
              <el-tag size="mini" effect="plain" type="success">执行结案：{{ scope.row.settleDateExecution }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="110" align="center" label="委托日期" sortable prop="entrustmentDate"
          column-key="entrustmentDate">
          <template slot-scope="scope">
            <span>{{ scope.row.entrustmentDate }}</span>
          </template>
        </el-table-column>
        <el-table-column width="140" align="center" label="创建时间" sortable prop="createTime" column-key="createTime">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }} </span>
          </template>
        </el-table-column>

      </el-table>
      <!-- 分页 -->
      <template slot="footer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="query.page" :page-sizes="[10, 20, 50, 100, 200, 500, 1000, 2000]" :page-size="query.limit"
          layout="total, sizes, prev, pager, next, jumper" :total="caseList.total">
        </el-pagination>
      </template>
    </el-dialog>

    <!-- 预览案件 -->
    <el-dialog class="previewDialog" custom-class="heightFull" :title="'预览案件'" :visible.sync="isPreview" width="70%"
      center :close-on-click-modal="false">
      <Preview :caseId="this.id" v-if="isPreview"></Preview>
    </el-dialog>
  </div>


</template>
<script>
var bankChart = undefined;
var courtBankChart = undefined;
var domChart = undefined;
var dom2Chart = undefined;
var courtChart = undefined;

import { mapState } from "vuex";
import * as echarts from "echarts";
import {
  getCaseViewData,
  getCourtStatistics,
  geBankStatistics,
  getCountAndBankStatistics,
} from "@/api/czManager/czCaseInfo/index";
import { selectCause } from "@/api/czManager/czCaseInfo/index";
import { getYearFirstDay, getYearLastDay, getStartDayOfMonth, getEndDayOfMonth, getNowDay } from '@/utils/dateUtils'
import { getCountList } from "@/api/index/index";
import Preview from "@/pages/caseMediate/preview";
export default {
  components: {
    Preview,
  },
  data() {
    return {
      isPreview: false,
      permissToImg: {
        // allCaseData: "img1",
        courtAndBankCaseData: "court-bank",
        courtCaseData: "court",
        allCaseDataProportion: "img3",
        bankCaseData: "bank",

      },
      causeList: [],
      cause: '信用卡纠纷',
      centerDialogVisible: false,
      isPermission: false,
      allImg: [],
      allHeight: "1600px",
      color: "red",
      form: {
        name: "",
        region: "11",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      isShowBox: false,
      courtKeyToText: {
        dianBaiCourt: "电白区法院",
        gaoZhouCourt: "高州市法院",
        huaZhouCourt: "化州市法院",
        maoNanCourt: "茂南区人民法院",
        noCourt: "处置中",
        xinYiCourt: "信宜法院",
      },
      caseKeyToText: {
        chuZhiZhong: "处置中",
        daiLiAn: "待立案",
        tiaoJieChengGong: "调解成功",
        tiaoJieZhong: "调解中",
        tijiaoFaYuan: "提交法院",
        yiCeSu: "已撤诉",
        yiLiAn: "已立案",
        yiTuiAn: "已退案",
        yiWanCheng: "已完成",
      },
      allCaseCount: "所有案件数",
      biaodi: "标的",
      caseStatusName: [],
      caseStatusValue: [],
      caseProportionName: [],
      casseProportionValue: [],
      boxData: {},
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      dateRange: [],
      dateOptions: [
        { value: 'entrustmentDate', label: '委托日期' },
        { value: 'filingDate', label: '立案日期' },
        { value: 'mediationDate', label: '调解日期' },
        { value: 'decisionDate', label: '判决日期' }
      ],
      dateType: 'entrustmentDate',
      query: {
        limit: 10,
        page: 1,
        start: '',
        end: '',
        court: '',
        bank: '',
        countType: '',
        dateType: '',
        cause: ''
      },
      statisticsParams: {
        start: '',
        end: '',
        countType: '',
        dateType: '',
        cause: ''
      },
      caseList: {
        records: [],
        total: 0
      },
      statParams: {
        start: '',
        end: '',
        dateType: '',
        cause: '信用卡纠纷'
      }

    };
  },
  computed: {
    ...mapState("d2admin/releases", ["version"]),
  },
  methods: {
    showEditPage(index, row) {
      this.id = row.id;
      this.isPreview = true;
      return;
    },
    setParams() {
      this.statParams.cause = this.cause
      if (this.dateRange != null) {
        if (this.dateRange.length > 0) {
          this.statParams = { start: this.dateRange[0], end: this.dateRange[1], dateType: this.dateType, cause: this.cause }
          this.statParams.start = this.dateRange[0]
          this.statParams.end = this.dateRange[1]
          this.statParams.dateType = this.dateType
          this.statParams.cause = this.cause
        } else {
          this.statParams.start = ''
          this.statParams.end = ''
        }
      }
    },
    gotoCaseListPage() {
      this.$router.push({ path: '/caseMediate/czCaseInfo' })
    },
    getBoxCount() {
      if (
        this.$store.state.d2admin.permission.kyObj["allCaseDataProportion"] != 1
      ) {
        return;
      }

      getCaseViewData(this.statParams).then((res) => {
        this.boxData = res;
      });
    },
    drawCourtStatusCaseData() {
      if (this.$store.state.d2admin.permission.kyObj["courtCaseData"] != 1) {
        return;
      }

      getCourtStatistics(this.statParams).then((res) => {
        var dataList = [];
        var yData = [];
        var courtDom = document.getElementById("court");
        courtChart = echarts.init(courtDom);

        for (let i = 0; i < res.length; i++) {
          yData.push(res[i].court);
        }
        for (let i = 0; i < res[0].value.length; i++) {
          var xData = [];
          var lastJ;
          for (let j = 0; j < res.length; j++) {
            xData.push(res[j].value[i].count);
            lastJ = j;
          }
          dataList.push({
            name: res[lastJ].value[i].name,
            type: "bar",
            stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: xData,
          });
        }
        var courtBankDom = document.getElementById("court-bank");
        courtBankChart = echarts.init(courtBankDom);
        var option = {
          title: {
            text: "法院各状态案件数量（件）",
            left: "center",
            top: "5%",
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
          },
          legend: {
            top: "13%",
            left: "center",
          },
          grid: {
            left: "5%",
            right: "5%",
            top: "25%",
            containLabel: true,

            height: "60%",
          },
          xAxis: {
            type: "value",
          },
          yAxis: {
            type: "category",
            data: yData,
          },
          series: dataList,
        };
        courtChart.setOption(option);
      });
    },
    drawCourtBankData() {
      if (
        this.$store.state.d2admin.permission.kyObj["courtAndBankCaseData"] != 1
      ) {
        return;
      }
      var dataList = [];
      var yData = [];
      getCountAndBankStatistics(this.statParams).then((res) => {
        for (let i = 0; i < res.length; i++) {
          yData.push(res[i].name);
        }
        for (let i = 0; i < res[0].value.length; i++) {
          var xData = [];
          var lastJ;
          for (var j = 0; j < res.length; j++) {
            xData.push(res[j].value[i].count);
            lastJ = j;
          }
          dataList.push({
            name: splisStr(res[lastJ].value[i].bankName),
            type: "bar",
            stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: xData,
          });
          var courtBankDom = document.getElementById("court-bank");
          courtBankChart = echarts.init(courtBankDom);
          var option = {
            title: {
              text: "法院各银行案件数量（件）",
              left: "center",
              top: "5%",
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                // Use axis to trigger tooltip
                type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
              },
            },
            legend: {
              top: "10%",
              left: "center",
            },
            grid: {
              left: "5%",
              right: "5%",
              top: "25%",
              containLabel: true,

              height: "60%",
            },
            xAxis: {
              type: "value",
            },
            yAxis: {
              type: "category",
              data: yData,
            },
            series: dataList,
          };
        }

        courtBankChart.setOption(option);
      });
    },


    drawBankCaseData() {
      if (this.$store.state.d2admin.permission.kyObj["bankCaseData"] != 1) {
        return;
      }

      geBankStatistics(this.statParams).then((res) => {
        var bankDom = document.getElementById("bank");
        bankChart = echarts.init(bankDom);
        var data = [];
        for (let i = 0; i < res.length; i++) {
          data.push({ name: splisStr(res[i].bankName), value: res[i].count });
        }
        var option = {
          title: {
            text: "各银行案件占比",
            left: "center",
            top: "5%",
          },
          // tooltip: {
          //   trigger: "item",
          // },
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: "center",
          },
          tooltip: {
            trigger: "item",
          },

          label: {
            formatter: "{d}%",
            // formatter: "{b} {c} 件\n{d}%",
            labelLine: {
              show: true,
            },
            borderWidth: 20,
            borderRadius: 4,
            rich: {
              a: {
                color: "#333",
                fontSize: 12,
                lineHeight: 20,
              },
              b: {
                fontSize: 12,
                lineHeight: 20,
                color: "#333",
              },
            },
          },
          grid: {
            left: "5%",
            right: "5%",
            top: "25%",
            containLabel: true,
            height: "65%",
          },
          series: [
            {
              name: "银行名",
              type: "pie",
              radius: ["20%", "50%"],
              avoidLabelOverlap: false,

              data: data,
              height: "100%",
              top: "15%",
            },
          ],
          legend: {
            top: "13%",
            left: "center",
          },
        };
        bankChart.setOption(option);
      });
    },
    drawImg1AndImg2() {
      if (
        this.$store.state.d2admin.permission.kyObj["allCaseDataProportion"] != 1
      ) {
        return;
      }

      getCaseViewData(this.statParams).then((res) => {
        this.caseStatusName = [];
        this.caseStatusValue = [];
        for (let key in this.caseKeyToText) {
          this.caseStatusName.push(this.caseKeyToText[key]);
          this.caseStatusValue.push(res[key]);
          for (let i = 0; i < this.allImg.length; i++) {
            document.getElementById(this.allImg[i]);
          }

          var imgDom2 = document.getElementById("img3");
          if (imgDom2 != null) {
            let dataList = [];
            for (let i = 0; i < this.caseStatusName.length; i++) {
              dataList.push({
                value: this.caseStatusValue[i],
                name: this.caseStatusName[i],
              });
            }
            dom2Chart = echarts.init(imgDom2);
            dom2Chart.setOption({
              title: {
                text: "案件状态总数占比",
                // subtext: "Fake Data",
                left: "center",
                top: "5%",
              },
              tooltip: {
                trigger: "item",
              },
              grid: {
                left: "5%",
                right: "5%",
                top: "25%",
                containLabel: true,

                height: "65%",
              },
              legend: {
                top: "13%",
                left: "center",
              },
              label: {
                formatter: "{b} {c} 件\n{d}%",
                // borderWidth: 20,
                // borderRadius: 4,
                labelLine: {
                  show: true,
                },
                borderWidth: 20,
                borderRadius: 4,
                // padding: [0, -50],
                rich: {
                  a: {
                    color: "#333",
                    fontSize: 12,
                    lineHeight: 20,
                  },
                  b: {
                    fontSize: 12,
                    lineHeight: 20,
                    color: "#333",
                  },
                },
              },
              labelLine: {
                length: 120,
                length2: 170,
              },

              series: [
                {
                  top: "15%",
                  name: "案件数",
                  type: "pie",
                  radius: "60%",
                  data: dataList,

                  labelLine: {
                    normal: {
                      length: 30,
                    },
                  },
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                  },
                },
              ],
            });
          }
        }
      });
    },

    detailList(status) {
      this.query.countType = status
      this.query.page = 1
      this.getList()
    },

    getList() {
      this.query.cause = this.cause
      this.query.dateType = this.dateType
      if (this.dateRange != null && this.dateRange.length > 0) {
        this.query.start = this.dateRange[0]
        this.query.end = this.dateRange[1]
      } else {
        this.query.start = ''
        this.query.end = ''
      }
      getCountList(this.query).then((res) => {
        this.caseList.records = res.records
        this.caseList.total = res.total;

      });
      this.centerDialogVisible = true;
    },

    handleSizeChange(val) {
      this.query.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getList();
    },




    //日期改变
    dateChange() {
      this.setParams()
      this.getBoxCount();
      this.drawCourtBankData();
      this.drawCourtStatusCaseData();
      this.drawBankCaseData();
      this.drawImg1AndImg2();
    },
    statistics(value) {
      if (value == 'all') {
        this.$refs["btn1"].$el["style"].fontWeight = 1000;
        this.$refs["btn2"].$el["style"].fontWeight = 500;
        this.$refs["btn3"].$el["style"].fontWeight = 500;
        this.$refs["btn4"].$el["style"].fontWeight = 500;
        this.dateRange = [];
        this.dateChange();
      } else if (value == 'year') {
        this.$refs["btn1"].$el["style"].fontWeight = 500;
        this.$refs["btn2"].$el["style"].fontWeight = 1000;
        this.$refs["btn3"].$el["style"].fontWeight = 500;
        this.$refs["btn4"].$el["style"].fontWeight = 500;
        let startDate = getYearFirstDay()
        let endDate = getYearLastDay();
        this.dateRange = [];
        this.dateRange.push(startDate)
        this.dateRange.push(endDate)
        this.dateChange();
      } else if (value == 'month') {
        this.$refs["btn1"].$el["style"].fontWeight = 500;
        this.$refs["btn2"].$el["style"].fontWeight = 500;
        this.$refs["btn3"].$el["style"].fontWeight = 1000;
        this.$refs["btn4"].$el["style"].fontWeight = 500;
        let startDate = getStartDayOfMonth()
        let endDate = getEndDayOfMonth();
        this.dateRange = [];
        this.dateRange.push(startDate)
        this.dateRange.push(endDate)
        this.dateChange();
      } else if (value == 'day') {
        this.$refs["btn1"].$el["style"].fontWeight = 500;
        this.$refs["btn2"].$el["style"].fontWeight = 500;
        this.$refs["btn3"].$el["style"].fontWeight = 500;
        this.$refs["btn4"].$el["style"].fontWeight = 1000;
        let startDate = getNowDay()
        let endDate = getNowDay();
        this.dateRange = [];
        this.dateRange.push(startDate)
        this.dateRange.push(endDate)
        this.dateChange();
      } else {
        this.dateRange = [];
        this.dateChange();
      }

    }
  },
  created() {
    let index = 0;

    for (let key in this.permissToImg) {
      if (this.$store.state.d2admin.permission.kyObj[key] == 1) {
        this.allImg[index++] = this.permissToImg[key];
      }
    }
    this.isShowBox =
      this.$store.state.d2admin.permission.kyObj["allCaseDataProportion"] == 1
        ? true
        : false;

    selectCause().then((response) => {
      this.causeList = response;
    });
  },
  updated() { },
  async mounted() {
    this.getBoxCount();
    await this.drawCourtStatusCaseData();
    await this.drawCourtBankData();
    await this.drawBankCaseData();
    await this.drawImg1AndImg2();
    setTimeout(() => {
      window.onresize = () => {
        if (domChart != undefined) {
          domChart.resize();
        }

        if (dom2Chart != undefined) {
          dom2Chart.resize();
        }
        if (courtBankChart != undefined) {
          courtBankChart.resize();
        }
        if (bankChart != undefined) {
          bankChart.resize();
        }
        if (courtChart != undefined) {
          courtChart.resize();
        }
      };
    }, 2000);
    // setTimeout(() => {
    //   this.allHeight =
    //     parseInt(
    //       (this.allImg.length / 2 + (this.allImg.length % 2)) * 500 +
    //         150 +
    //         (this.allImg.length / 2 + (this.allImg.length % 2)) * 40 +
    //         400
    //     ) + "px";
    // }, 2000)
    // ;
    // this.allHeight = '1200px'
  },
};
var splisStr = function (str) {
  str = str.replace('中国建设银行股份有限公司', '建行')
    .replace('中国农业银行股份有限公司', '农行').replace("广发银行股份有限公司", '广发')
    .replace("市", "").replace("茂名", "")
    .replace("中国工商银行股份有限公司", '工行')
    .replace("中国银行股份有限公司", '中行')
    .replace("交通银行股份有限公司", '交行');
  return str
}



</script>

<style lang="scss" scoped>
@import "~@/assets/style/public.scss";

.allCaseText:hover {
  cursor: pointer;
}

.center-absolute {
  top: 45%;
  width: 3vw !important;
  height: 3vh !important;
  left: 20%;
  transform: translate(0%, -60%);
}

.font-class {
  color: grey;
}

.box-card {
  height: 100%;
  text-align: center;
  line-height: 100%;
}

.countBox {
  display: flex;
  justify-content: space-around;
  padding: 10px;
  height: 12vh;
}

.text-class {
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
}

.flex-layout {
  display: flex;
  justify-content: space-evenly;
}

.box-item {
  position: relative;
  width: 100%;
  margin: 0 1rem;
  background-color: white;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.imgClass {
  background-color: white;
  // width: 40%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  height: 35em;
}

.zhuzi {
  // position: absolute;
  width: 50% !important;
  margin-left: 1rem;
}

.circle {
  width: 50%;
  margin-left: 2em;
}

.card_text {
  width: 30%;
  // height: 250px;
  height: 20em;
  text-align: center;
  line-height: 20em;
  font-size: 26px;
}

.searchBox {
  width: 100%;
  padding: 10px 0;
  // background: ;
}

.header {
  width: 98%;
  margin: 0 1%;
  display: flex;
}

.c {
  background-color: red;
}

.content {
  // max-height: 500px;
  // margin: 1%;
  width: 100%;
  // box-shadow:10px 4px 1px rgb(117, 112, 112);
  // margin: 20px 1%;
  // padding: 0 2%;
  display: flex;
}

.page {
  .page__logo {
    width: 120px;
  }

  .page__btn-group {
    color: $color-text-placehoder;
    font-size: 12px;
    margin-top: -10px;
    margin-bottom: 20px;

    span {
      color: $color-text-sub;

      &:hover {
        color: $color-text-main;
      }
    }
  }
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 40px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}


.el-col {
  // height: 6vh;
  // line-height: 6vh;
  //  line-height: 12vh;
  //  justify-items: center;
  //  align-items: center;
}
</style>
